import { useState, useEffect, useContext, useMemo } from 'react'
import { useLocation, useParams, useNavigate } from 'react-router-dom'

import { AppContext } from '/providers/app-context'
import { getPass } from '/providers/passes-api'

import PageWrapper from '/components/page-wrapper'
import StyledPaper from '/components/paper'
import HelpText from '/help/pass-details'
import Menu from '/components/passes/pass-nav-menu'

import EditForm from '/components/passes/editor'
import GiftcardEditor from './pass-editor-gift'
import EventTicketEditor from './pass-editor-event'
import StampcardEditor from './pass-editor-stamp'
import LoyaltyEditor from './pass-editor-loyalty'
const PassEditor = () => {

  const navigate = useNavigate()
  const location = useLocation()

  const { templateId, passId } = useParams()
  const { apiSource, apiKeys, templates } = useContext(AppContext)
  const [pass, setPass] = useState(location.state?.pass)
  const template = useMemo(() => { return templates.filter(t => t.id === templateId)[0] }, [templates, templateId])

  useEffect(() => {
    getPassData()
  }, [])

  const getPassData = async () => {
    const p = await getPass({ apiSource, apiKeys, templateId, passId })
    if (p.ok === false) navigate("/templates")
    setPass(p.pass)
  }

  const setLocationStatePass = pass => {
    navigate(location.pathname,{replace:true,state:{...location.state,pass}})
  }

  return (
    <PageWrapper title="Pass Editor" HelpText={HelpText} heading={`${pass?.pass_id} ${pass?.mode === "test" ? " [test]" : ""}`} menu={<Menu pass={pass} template={template} />}>
      <Content templateId={templateId} template={template} pass={pass} getPass={getPassData} setPass={setLocationStatePass} />
    </PageWrapper>
  )
}

export default PassEditor

const Content = ({ templateId, template, pass, setPass }) => {

  if (template?.smartix_scanner) return (
    <SmartixScannerEditForm pass={pass} template={template} setPass={setPass} />
  )
  else return (
    <>
      <div className='overflow-y-scroll h-full pb-32 flex flex-wrap gap-5 min-w-[800px] w-full'>
        <div className='flex-grow flex-shrink min-w-[400px] max-w-[700px]'>
          <StyledPaper>
            <pre>{JSON.stringify(pass?.instance_data, null, 2)}</pre>
          </StyledPaper>
        </div>
        <div className='flex-grow flex-shrink min-w-[400px] max-w-[700px]'>
          <StyledPaper>
            <EditForm pass={pass} templateId={templateId} setPass={setPass} />
          </StyledPaper>
        </div>
      </div>
    </>
  )
}

const SmartixScannerEditForm = ({ pass, template, setPass }) => {

  if (pass && template)
    switch (template?.pass_type_id) {
    case "smartix_gift": return <GiftcardEditor pass={pass} template={template} setPass={setPass} />
    case "smartix_stamp": return <StampcardEditor pass={pass} template={template} setPass={setPass} />
    case "smartix_event": return <EventTicketEditor pass={pass} template={template} setPass={setPass} />
    case "smartix_loyalty": return <LoyaltyEditor pass={pass} template={template} setPass={setPass} />
  }
}